import React, { Component } from "react";

import "./Top.less";

export default class Top extends Component {

  onDivRef = (e) => {
    if (e) {
      const pEle = e.parentElement;
      if (pEle.classList.contains("nano-panel")) {
        // 调整父 .nano-panel 的 垂直布局
        pEle.style.flexDirection = "column";
      }
    };
  }

  render() {
    const style = {
      ...this.props.style,
      height: this.props.height,
    };
    return (
      <div
        className={"nano-panel-top " + (this.props.className || "")}
        style={style}
        ref={this.onDivRef}
      >
        {this.props.children}
      </div>
    );
  };
}
